export default {"src":"/_next/static/media/sadFace_64.c7ef25b7.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};